export type CacheBackend<V> = {
  clear(): Promise<void>
  delete(key: string): Promise<void>
  exists(key: string): Promise<boolean>
  get(key: string): Promise<undefined | V>
  set(key: string, value: V): Promise<void>
}

export type SearchCacheBackend<V> = {
  startswith(prefix?: string): Promise<Record<string, V>>
} & CacheBackend<V>
